<template>
  <v-container id="home">
    <v-layout align-top justify-center>
      <v-flex xs12 sm10 md12 lg10>
        <v-sheet>
          <v-row>
            <v-col cols="12" md="5" v-if="!$vuetify.breakpoint.smAndDown">
              <v-card
                dark
                color="secondary"
                class="pa-0"
                v-if="!$vuetify.breakpoint.smAndDown"
              >
                <v-card-title>
                  {{ this.company.PartyName }}
                </v-card-title>
                <v-card-subtitle>
                  {{ this.company.PartyIdentification }}<br />
                  {{ this.company.AddressLine + " , " + this.company.CityName }}<br />
                </v-card-subtitle>
              </v-card>

              <v-list class="cart-list py-0 mt-6">
                <!-- Empty cart message -->
                <v-list-item v-if="!cart.length" class="text-center grey--text">
                  <v-list-item-content>
                    <v-icon size="64" class="mb-2">mdi-cart-outline</v-icon>
                    <div>El carrito está vacío</div>
                  </v-list-item-content>
                </v-list-item>

                <!-- Cart items -->
                <template>
                  <v-list-item
                    v-for="item in cart"
                    :key="item.ean"
                    @click="editItem(item)"
                    class="item-row"
                  >
                    <v-list-item-avatar size="40" class="my-0 mr-3">
                      <v-icon>mdi-package-variant-closed</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content class="py-1">
                      <v-list-item-title class="text-body-1 font-weight-medium">
                        {{ item.nombre || item.marca }}
                      </v-list-item-title>
                      <v-list-item-subtitle
                        v-if="itemDetail(item)"
                        class="text-caption grey--text"
                      >
                        {{ itemDetail(item) }}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle
                        v-if="item.note"
                        class="text--primary text-caption"
                      >
                        {{ item.note }}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle class="text-caption">
                        <span class="mr-2">{{ item.cantidad }} unid</span>
                        <span v-if="item.ean" class="grey--text">{{ item.ean }}</span>
                      </v-list-item-subtitle>
                    </v-list-item-content>

                    <div class="text-right price-column">
                      <div class="font-weight-medium">
                        {{ formatCurrency(item.precio * item.cantidad) }}
                      </div>
                      <small
                        v-if="item.discount > 0"
                        class="red--text text-decoration-line-through"
                      >
                        {{
                          formatCurrency((item.discount + item.precio) * item.cantidad)
                        }}
                      </small>
                    </div>
                  </v-list-item>

                  <v-divider></v-divider>
                </template>

                <!-- Totals -->
                <v-divider v-if="cart.length"></v-divider>
                <v-list-item v-if="cart.length" class="total-row primary lighten-5">
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">
                      Totales
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ sumField(cart, "cantidad").toLocaleString("es") }} artículos
                    </v-list-item-subtitle>
                  </v-list-item-content>

                  <div class="text-right price-column">
                    <div class="font-weight-bold text-h6 primary--text">
                      {{ formatCurrency(this.totals.total) }}
                    </div>
                  </div>
                </v-list-item>
              </v-list>
              <v-row class="mt-6">
                <!-- <v-col cols="6" sm="4">
                  <v-text-field
                    v-model="bags"
                    class="center-input"
                    background-color="#FFE0B2"
                    label="Bolsas"
                    outlined
                    hide-details
                    prepend-inner-icon="mdi-minus"
                    append-icon="mdi-plus"
                    @click:prepend-inner="restQty"
                    @click:append="addQty"
                  />
                </v-col> -->
                <v-col cols="6" sm="6">
                  <v-text-field
                    v-model="discount"
                    @keyup="discountApply"
                    outlined
                    label="Descuento"
                    class="center-input"
                    background-color="#FFCDD2"
                    type="number"
                    hide-details
                    append-icon="mdi-percent-outline"
                  />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-btn
                    class="right-input"
                    @click="openPaymentDialog"
                    block
                    color="success"
                    :disabled="totals.unpaid === 0"
                    x-large
                    >{{ formatCurrency(this.totals.unpaid) }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="7">
              <PLU
                :cartItemTotal="totals.unpaid"
                @product-selected="add2cart"
                @product-not-found="skuError = true"
                @products_dialog="search_dialog = !search_dialog"
                @fastPayment="fastPayment"
                @cart-show="cartDrawerOpen = !cartDrawerOpen"
              />
            </v-col>
          </v-row>
        </v-sheet>
      </v-flex>
    </v-layout>

    <v-snackbar
      v-model="skuError"
      :timeout="timeout_error"
      absolute
      centered
      dark
      color="red"
      elevation="24"
    >
      Producto no encontrado en el inventario ...
    </v-snackbar>

    <v-dialog
      v-model="search_dialog"
      transition="dialog-fade-transition"
      scrollable
      max-width="800px"
      :fullscreen="$vuetify.breakpoint.smAndDown"
    >
      <v-form v-model="search_valid" ref="searchform" @submit="search_inventory">
        <v-card>
          <v-card-title class="pa-0">
            <v-toolbar flat>
              <v-toolbar-title>Buscar en el Inventario</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn fab icon @click="search_dialog = !search_dialog">
                <v-icon> mdi-close </v-icon>
              </v-btn>
            </v-toolbar>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers[$vuetify.breakpoint.xsOnly]"
              :items="inventory_lst"
              :items-per-page="5"
              class="elevation-4"
              mobile-breakpoint="0"
              item-key="ean"
              :loading="loading_status"
              loader-height="10"
              loading-text="Cargando ..."
            >
              <template v-slot:top>
                <v-row class="ma-3">
                  <v-col cols="12" md="5">
                    <v-select
                      v-model="filters.field"
                      :items="['NOMBRE', 'CATEGORIA', 'GRUPO', 'MARCA', 'REFE', 'COLOR', 'TALLA']"
                      label="Criterio"
                      placeholder="Seleccionar"
                      hide-details="auto"
                    />
                  </v-col>

                  <v-col cols="12" md="5">
                    <v-text-field
                      v-model="filters.value"
                      label="Buscar"
                      clearable
                      hide-details="auto"
                      required
                    >
                      <template v-slot:prepend> </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-btn
                      :disabled="!filters.field || !filters.value"
                      block
                      color="success"
                      x-large
                      type="submit"
                    >
                      Buscar
                    </v-btn>
                  </v-col>
                </v-row>
              </template>

              <template v-slot:[`item.marca`]="{ item }">
                <div class="font-weight-medium">{{ item.nombre || item.marca }}</div>
                <small v-if="itemDetail(item)" class="grey--text">
                  {{ itemDetail(item) }}
                </small>
              </template>
              <template
                v-slot:[`item.precio`]="{ item }"
                v-if="$vuetify.breakpoint.xsOnly"
              >
                <v-chip color="green" dark filter pill @click="add2cart(item)">
                  {{ formatCurrency(parseFloat(item.precio)) }}
                </v-chip>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <v-icon class="mr-2" @click="add2cart(item)">
                  mdi-plus-box-outline
                </v-icon>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-form>
      <v-snackbar
        v-model="productAdded"
        :timeout="timeout"
        absolute
        centered
        dark
        color="orange"
        elevation="24"
      >
        Producto agregado ...
      </v-snackbar>
    </v-dialog>

    <v-dialog v-model="edit_dialog" max-width="600px">
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat rounded>
            <v-toolbar-title>Editar producto</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="edit_dialog = !edit_dialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>

        <v-card-text>
          <v-list>
            <v-list-item>
              <v-btn class="mx-1 mr-2" icon disabled>
                {{ itemEdit.cantidad }}
              </v-btn>
              <v-list-item-content>
                <v-list-item-title v-text="itemEdit.nombre || itemEdit.marca" />
                <v-list-item-subtitle
                  class="text--primary"
                  v-text="itemDetail(itemEdit)"
                />
              </v-list-item-content>
              <v-list-item-action>
                <span
                  class="red--text text-decoration-line-through"
                  v-if="itemEdit.discount > 0"
                >
                  {{
                    formatCurrency(
                      (itemEdit.discount + itemEdit.precio) * itemEdit.cantidad
                    )
                  }}
                </span>
                <span v-if="itemEdit.discount > 0">
                  {{ "- " + formatCurrency(parseFloat(itemEdit.discount)) }}
                </span>
                <span class="font-weight-bold">
                  {{ formatCurrency(itemEdit.precio * itemEdit.cantidad) }}
                </span>
              </v-list-item-action>
            </v-list-item>
          </v-list>

          <!-- New Note Field -->
          <v-textarea
            v-model="itemEdit.note"
            label="Nota"
            placeholder="Agregar nota sobre este producto..."
            rows="2"
            outlined
            hide-details
            class="mt-3"
          ></v-textarea>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="py-3">
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                @change="updateTotal"
                v-model="itemEdit.cantidad"
                label="Cantidad"
                placeholder="Cantidad"
                type="number"
                min="1"
                hide-details
                outlined
                dense
                class="mx-2"
              >
                <template v-slot:prepend>
                  <v-btn
                    small
                    icon
                    @click="decrementQuantity"
                    :disabled="itemEdit.cantidad <= 1"
                  >
                    <v-icon>mdi-minus</v-icon>
                  </v-btn>
                </template>
                <template v-slot:append>
                  <v-btn small icon @click="incrementQuantity">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>
              </v-text-field>
            </v-col>

            <v-col cols="12" sm="6">
              <v-text-field
                v-model="itemEdit.descuento"
                @keyup="itemdiscountApply"
                label="Descuento"
                placeholder="Descuento"
                type="number"
                hide-details
                outlined
                dense
                class="mx-2"
                append-icon="mdi-percent-outline"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-actions>

        <v-divider></v-divider>

        <v-card-actions class="px-4 py-3">
          <v-btn color="error" text @click="removeItem(itemEdit)">
            <v-icon left>mdi-delete</v-icon>
            Eliminar
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn color="primary" @click="saveChanges">
            <v-icon left>mdi-check</v-icon>
            Guardar cambios
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="client_dialog" max-width="600px">
      <v-card
        :loading="loading_status"
        loader-height="10"
        loading-text="Cargando ..."
        class="client-dialog"
      >
        <v-toolbar flat color="transparent" class="client-header">
          <v-toolbar-title class="client-title">
            <span class="gradient-text">Cliente</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="client_dialog = !client_dialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider></v-divider>

        <v-card-text class="pa-6">
          <v-row>
            <v-col cols="12" sm="6">
              <v-select
                v-model="client.typeid"
                :items="id_lst"
                item-value="code"
                item-text="name"
                label="Tipo de documento"
                placeholder="Tipo de documento"
                outlined
                dense
                hide-details="auto"
                class="mb-4"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="client.PartyIdentification"
                label="Número de documento"
                ref="idNumber"
                clearable
                outlined
                dense
                hide-details="auto"
                autofocus
                type="number"
                @keyup="validateID"
                @keypress="filter"
                append-icon="mdi-magnify"
                @click:append="get_rut"
                @click:clear="clearClient"
                class="mb-4"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="client.PartyName"
                label="Nombre Completo"
                outlined
                dense
                hide-details="auto"
                class="mb-4"
              />
            </v-col>
            <v-col cols="12" sm="8">
              <v-text-field
                v-model="client.client_email"
                label="Correo Electrónico"
                placeholder="Correo Electrónico"
                outlined
                dense
                hide-details="auto"
                type="email"
                class="mb-4"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                v-model="client.client_phone"
                label="Celular"
                outlined
                dense
                hide-details="auto"
                type="number"
                @keypress="filter(event)"
                class="mb-4"
              />
            </v-col>
            <v-col cols="12" sm="8">
              <v-text-field
                v-model="client.AddressLine"
                label="Dirección"
                outlined
                dense
                hide-details="auto"
                class="mb-4"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-autocomplete
                v-model="client.CityName"
                :items="setting['municipalities']"
                item-value="id"
                item-text="name"
                label="Ciudad"
                placeholder="Ciudad"
                outlined
                dense
                hide-details="auto"
                class="mb-4"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-6">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            depressed
            large
            type="button"
            @click="save_client"
            class="px-8 gradient-button"
          >
            <v-icon left>mdi-content-save</v-icon>
            Guardar Cliente
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <v-dialog
      v-model="payment_dialogo"
      max-width="600px"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      transition="dialog-fade-transition"
      scrollable
    >
      <v-form v-model="payvalid" ref="payform" @submit="addPayment">
        <v-card elevation="1" class="pa-2">
          <v-card-title class="pa-0">
            <v-toolbar flat dense color="transparent" class="checkout-header">
              <v-toolbar-title class="checkout-title">
                <span class="gradient-text">Forma de Pago</span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="payment_dialogo = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" md="8">
                <h3 class="subtitle-1 font-weight-medium mb-2">Tipo de documento</h3>
                <v-select
                  v-model="doctype"
                  :items="doctypes"
                  item-value="value"
                  item-text="label"
                  label="Tipo de documento"
                  outlined
                  dense
                  :hint="getDocumentTypeHint()"
                  persistent-hint
                  hide-details="auto"
                  @change="onDocTypeChange"
                  class="mb-2"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-checkbox
                  v-if="doctype !== 'invoice'"
                  v-model="clienteSolicitaFactura"
                  label="Factura completa"
                  hide-details="auto"
                  class="mt-6"
                  @change="checkFacturaRequerida"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" v-if="needsClientInfo">
                <div class="d-flex align-center mb-2">
                  <h3 class="subtitle-1 font-weight-medium">Información del cliente</h3>
                  <v-spacer></v-spacer>
                  <v-btn
                    small
                    outlined
                    color="primary"
                    @click="client_dialog = !client_dialog"
                    class="px-2"
                  >
                    <v-icon left small>mdi-magnify</v-icon>
                    Seleccionar
                  </v-btn>
                </div>
                <v-card outlined class="customer-info pa-4" v-if="client.PartyName">
                  <div class="d-flex align-center mb-2">
                    <v-avatar color="primary" size="32" class="mr-3">
                      <span class="white--text headline">{{
                        client.PartyName.charAt(0)
                      }}</span>
                    </v-avatar>
                    <div class="body-1 font-weight-medium">{{ client.PartyName }}</div>
                  </div>
                  <div class="caption text--secondary mb-1">
                    {{ get_name_typeId(client.typeid) }}: {{ client.PartyIdentification }}
                  </div>
                  <div class="caption text--secondary mb-1">
                    {{ client.AddressLine }}, {{ get_name_city(client.CityName) }}
                  </div>
                  <div class="caption text--secondary">{{ client.client_email }}</div>
                </v-card>
                <v-card outlined class="customer-info pa-2" v-else>
                  <v-skeleton-loader type="list-item-avatar-two-line" />
                </v-card>
              </v-col>
              <v-col cols="12">
                <h3 class="subtitle-1 font-weight-medium mb-3">Detalles del pago</h3>
                <v-select
                  v-model="vendor"
                  :items="vendors"
                  item-value="codigo"
                  item-text="nombre"
                  label="Vendor"
                  outlined
                  dense
                  required
                  hide-details="auto"
                  @change="validate_invoice"
                  :error="!validations[4].status"
                  :error-messages="validations[4].label"
                  class="mb-4"
                />
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="pay_mode"
                  :items="FP"
                  return-object
                  item-value="codigo"
                  item-text="valor"
                  label="Payment Method"
                  outlined
                  dense
                  hide-details="auto"
                  class="mb-4"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="payment.payment_reference"
                  label="Código de referencia"
                  :error="payRefe"
                  @input="updateRefe"
                  required
                  outlined
                  dense
                  hide-details="auto"
                  class="mb-4"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  :value="formatCurrency(payment.payment_value)"
                  @input="handlePaymentInput"
                  label="Valor"
                  :error="payValue"
                  :rules="payRule"
                  clearable
                  outlined
                  dense
                  required
                  hide-details="auto"
                  class="mb-4"
                />
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              depressed
              large
              type="submit"
              class="px-8 gradient-button"
            >
              <v-icon left>mdi-check-circle</v-icon>
              Completar el pago
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog> -->

    <v-dialog v-model="st_dialog" max-width="800px">
      <v-card>
        <v-tabs show-arrows centered class="fixed-top-b">
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            v-for="menu in menus"
            :key="menu"
            :href="'#tab-' + menu"
            @click="changeMenu(menu)"
          >
            {{ menu }}
          </v-tab>
        </v-tabs>
        <v-card-text>
          <v-row class="mt-6">
            <v-col
              class="col-6 col-sm-6 col-md-4"
              v-for="product in menu_selected"
              :key="product.ean"
            >
              <v-card height="100%" elevation="8" @click="add2cart_st(product.ean)">
                <v-img
                  cover
                  aspect-ratio="1"
                  max-height="300px"
                  :src="getImageURL(product.marca, product.refe)"
                >
                </v-img>
                <v-card-title dark>
                  <v-select
                    :items="get_options(product.options)"
                    label="Opciones"
                    item-value="ean"
                    item-text="description"
                  ></v-select>
                </v-card-title>
                <v-card-actions dark class="pa-2 card-actions bgb">
                  <v-spacer></v-spacer>
                  $ {{ product.precio }}
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <CheckoutComponent
      :visible.sync="payment_dialogo"
      :totalAmount="totals.total"
      :unpaidAmount="totals.unpaid"
      :vendors="vendors"
      :paymentMethods="FP"
      :idList="id_lst"
      :municipalities="setting['municipalities']"
      :companyData="company"
      :clientData="client"
      :validations="validations"
      @doc-type-changed="handleDocTypeChanged"
      @validation-updated="handleValidationUpdated"
      @process-payment="processPayment"
      @open-client-dialog="client_dialog = true"
      @show-message="showMessage"
    />

    <docViewer
      :item="item"
      :dialog="docViewdialog"
      :newInvoice="nInvoice"
      @close="docViewdialog = false"
      @refresh="refresh_view()"
    />

    <CartDrawer
      v-model="cartDrawerOpen"
      :items="cart"
      :total="totals.total"
      :bags-count="parseInt(bags)"
      :loading="loading_status"
      @edit-item="editItem"
      @remove-item="removeItem"
      @apply-discount="discountAppCart"
      @checkout="payment_dialogo = !payment_dialogo"
      @decreaseBags="restQty"
      @increaseBags="addQty"
      @updateBags="updateBags"
    />
  </v-container>
</template>

<script>
import { webserver, fe_ws } from "@/services/webserver.js";
import createItem from "@/utils/createItem.js";
import createClient from "@/utils/createClient.js";
import createPayment from "@/utils/createPayment.js";
import dianResponse from "@/utils/dianResponse.js";
import docViewer from "@/components/doc_viewer.vue";
import CheckoutComponent from "@/components/checkout.vue";
import createDoc from "@/utils/create_doc.js";
import settings from "@/utils/settings.js";
import createCompany from "@/utils/createCompany.js";
import PLU from "./PLUD.vue";
import CartDrawer from "@/views/pos/cart.vue";
import {
  getCurrentCountryCode,
  getCurrentCountrySettings,
  getDocumentTypes,
} from "@/utils/countryUtils.js";
import { formatCurrencyAdvanced } from "@/utils/currencyUtils.js";

// Defaults de "público en general" por país. Para Colombia el adquiriente
// no identificado en POS se reporta como CC 222222222222 (DIAN).
const CLIENTE_PUBLICO_DEFAULTS = {
  CO: {
    PartyName: "CONSUMIDOR FINAL",
    PartyIdentification: "222222222222",
    typeid: "CC",
  },
  ES: {
    PartyName: "PÚBLICO EN GENERAL",
    PartyIdentification: "000000000",
    typeid: "DNI",
  },
  MX: {
    PartyName: "PÚBLICO EN GENERAL",
    PartyIdentification: "XAXX010101000",
    typeid: "RFC",
  },
};

const buildClientePublicoGeneral = () => {
  const code = getCurrentCountryCode();
  const base = CLIENTE_PUBLICO_DEFAULTS[code] || CLIENTE_PUBLICO_DEFAULTS.ES;
  return {
    ...base,
    client_email: "",
    client_phone: "",
    AddressLine: "",
    CityName: "",
  };
};

// Tipos de documento de venta por país (para el selector del checkout).
// Estructura: { value, label, maxAmount, needsClient }
const buildDoctypesForCountry = () => {
  const code = getCurrentCountryCode();
  const cfg = getCurrentCountrySettings(code).country || {};
  const simplifiedLimit = cfg.simplifiedInvoiceLimit ?? Infinity;
  const fullLimit = cfg.requiresFullInvoiceLimit ?? Infinity;

  if (code === "ES") {
    return [
      { value: "TK", label: "Ticket básico", maxAmount: simplifiedLimit, needsClient: false },
      { value: "FS", label: "Factura Simplificada", maxAmount: fullLimit, needsClient: false },
      { value: "FC", label: "Factura Completa", maxAmount: Infinity, needsClient: true },
    ];
  }
  if (code === "CO") {
    // En Colombia el documento POS válido es la Factura Electrónica.
    // Por debajo del umbral simplificado se acepta consumidor final genérico.
    return [
      { value: "FE", label: "Factura Electrónica", maxAmount: Infinity, needsClient: false },
    ];
  }
  // Fallback genérico
  return [
    { value: "FC", label: "Factura", maxAmount: Infinity, needsClient: true },
  ];
};

export default {
  name: "Home",
  components: { docViewer, PLU, CartDrawer, CheckoutComponent },
  beforeMount() {
    this.get_data_company();
  },
  mounted() {
    //document.getElementById("sku").focus();
    console.log("mounted", window.settings);
    this.store = window.store;
    this.get_vendors();
    this.FP = window.settings?.FP || [
      { codigo: "01", valor: "EFECTIVO" },
      { codigo: "02", valor: "TARJETA DE CRÉDITO" },
      { codigo: "03", valor: "TARJETA DE DÉBITO" },
      { codigo: "04", valor: "TRANSFERENCIA" },
    ];
    this.CT = window.settings.CATEGORIA;
    this.MR = window.settings.MARCA;
    this.colors = window.settings.COLOR;
    this.seller = window.seller;
    this.setDefaultDocumentType();
  },
  data() {
    return {
      needsClientInfo: false,
      showClientOptions: false,
      clientType: "public", // Por defecto, público en general
      cartDrawerOpen: false,
      docViewdialog: false,
      company: createCompany(),
      doctype: "invoice",
      nInvoice: false,
      store: createClient(),
      connection: null,
      loading_status: false,
      loading_vendors: false,
      itemEdit: createItem(),
      editvalid: false,
      skuError: false,
      timeout: 250,
      timeout_error: 1000,
      edit_dialog: false,
      valid: false,
      productAdded: false,
      payvalid: false,
      search_valid: false,
      client_dialog: false,
      payment_dialogo: false,
      search_dialog: false,
      showPrint: false,
      filters: { field: "NOMBRE", value: "" },
      sku: null,
      cart: [],
      payments: [],
      payRefe: false,
      payValue: false,
      pay_mode: {
        codigo: "01",
        valor: "EFECTIVO",
      },
      payment: createPayment(),
      topay: true,
      discoutRule: (v) => {
        if (!v.trim()) return true;
        if (!isNaN(parseFloat(v)) && v >= 0 && v <= 50) return true;
        return "Debe ser un numero entre 0 y 50";
      },
      requiredRule: [(v) => (v && v !== null) || "Forma de pago requerida"],
      payRule: [
        (v) => !!v || "Forma de pago requerida",
        (v) =>
          (v && v <= this.totals.unpaid) ||
          "Valor max " + this.totals.unpaid.toLocaleString(2),
      ],
      // Cliente por defecto: el genérico del país (en CO: CONSUMIDOR FINAL,
      // CC 222222222222). Igual que InvoicePOS / InvoiceQ. Solo se cambia si
      // el cajero explícitamente selecciona / crea otro cliente.
      client: buildClientePublicoGeneral(),
      setting: settings(),
      id_lst: getDocumentTypes(),
      clienteSolicitaFactura: false,
      montoRequiereFactura: false,
      doctypes: buildDoctypesForCountry(),
      FP: [],
      CT: null,
      MR: null,
      colors: [],
      headers: {
        false: [
          {
            text: "Categoría",
            align: "start",
            sortable: true,
            value: "categoria",
            dataType: "text",
          },
          {
            text: "Grupo",
            align: "start",
            sortable: true,
            value: "grupo",
            dataType: "text",
          },

          {
            text: "Descripción",
            align: "start",
            sortable: true,
            value: "marca",
            dataType: "text",
          },

          {
            text: "Precio",
            align: "end",
            sortable: true,
            value: "precio",
            dataType: "number",
          },
          {
            text: "Descuento",
            align: "end",
            sortable: true,
            value: "descuento",
            dataType: "number",
          },
          { text: "", value: "actions", sortable: false },
        ],
        true: [
          {
            text: "Descripción",
            align: "start",
            sortable: true,
            value: "marca",
            dataType: "text",
          },
          {
            text: "Precio",
            align: "end",
            sortable: true,
            value: "precio",
            dataType: "number",
          },
        ],
      },
      headers_cart: [
        {
          text: "Descripción",
          align: "start",
          sortable: true,
          value: "refe",
          dataType: "text",
        },
        {
          text: "Qty",
          align: "center",
          sortable: true,
          value: "cantidad",
          dataType: "text",
          width: "10",
        },
        {
          text: "Precio",
          align: "end",
          sortable: true,
          value: "precio",
          dataType: "number",
        },
        // { text: "", align: "end", value: "actions", sortable: false, width: "5" },
      ],
      headers_payments: [
        {
          text: "Concepto",
          align: "start",
          value: "payment_concept",
          dataType: "text",
        },

        {
          text: "Valor",
          align: "end",
          sortable: true,
          value: "payment_value",
          dataType: "number",
        },
        { text: "", value: "actions", align: "end", sortable: false },
      ],
      inventory_lst: [],
      vendors: [],
      vendor: null,
      totals: { qty: 0, total: 0, tax: 0, paid: 0, unpaid: 0 },
      bags: 0,
      discount: null,
      dataURL: null,
      invoiceImg: null,
      st_items: [],
      itemsby: null,
      menus: null,
      menu_selected: null,
      menuName: null,
      st_dialog: false,
      eInvoice: null,
      seller: null,
      dian_dialog: false,
      dian_response: dianResponse(),
      docview: "",
      dialog: false,
      item: createDoc(),
      validations: [
        { status: false, label: "Deme suministrar nombre del cliente" },
        { status: false, label: "Correo electrónico es requerido" },
        { status: false, label: "Documento de identificación del Cliente es requerido" },
        { status: false, label: "El tipo de documento es requerido" },
        { status: true, label: "Vendor es requerido" },
        { status: false, label: "Requiere Factura Electrónica" },
        { status: false, label: "Valor" },
        { status: false, label: "Ciudad es requerido" },
      ],
      validForm: false,
      qtyRules: [
        (v) => !!v || "Cantidad es requerida",
        (v) => (v && v >= 0) || "No puede ser cero",
      ],
    };
  },
  methods: {
    handleDocTypeChanged(data) {
      this.doctype = data.doctype;
      this.needsClientInfo = data.needsClientInfo;
    },
    handleValidationUpdated(data) {
      this.validations = data.validations;
      return data.isValid;
    },
    showMessage(message) {
      this.$store.commit("setSnackbar", message);
    },
    processPayment(paymentData) {
      // Extract data
      const { payment, pay_mode, vendor, client, doctype } = paymentData;

      this.vendor = vendor;
      this.doctype = doctype;
      this.client = { ...client };

      if (pay_mode.codigo === "01") {
        if (payment.payment_value > this.totals.unpaid) {
          const cmb = parseFloat(payment.payment_value) - parseFloat(this.totals.unpaid);

          const newPayment = {
            payment_concept: pay_mode.valor,
            payment_code: pay_mode.codigo,
            payment_reference: payment.payment_reference,
            payment_value: this.totals.unpaid,
          };
          this.payments.push({ ...newPayment });

          const cambio = {
            payment_concept: "EFECTIVO",
            payment_code: "01",
            payment_reference: ` Cambio $ ${cmb}`,
            payment_value: 0,
          };
          this.payments.push({ ...cambio });
        } else {
          const newPayment = {
            payment_concept: pay_mode.valor,
            payment_code: pay_mode.codigo,
            payment_reference: payment.payment_reference,
            payment_value: payment.payment_value,
          };
          this.payments.push({ ...newPayment });
        }
      } else {
        if (payment.payment_value <= this.totals.unpaid) {
          const newPayment = {
            payment_concept: pay_mode.valor,
            payment_code: pay_mode.codigo,
            payment_reference: payment.payment_reference,
            payment_value: payment.payment_value,
          };
          this.payments.push({ ...newPayment });
        }
      }

      this.updateTotal();
    },
    onDocTypeChange() {
      // Buscar el tipo de documento seleccionado
      const selectedDocType = this.doctypes.find((doc) => doc.value === this.doctype);

      // Determinar si necesita información del cliente
      this.needsClientInfo = selectedDocType.needsClient || this.clienteSolicitaFactura;

      // Si necesita información del cliente y no hay cliente seleccionado,
      // configura el cliente como público en general por defecto
      if (this.needsClientInfo && !this.client.PartyName) {
        this.client = { ...buildClientePublicoGeneral() };
        this.client.CityName = this.company.city_code;
      }

      // Validar si el tipo seleccionado es adecuado para el monto
      this.validate_doctype();
    },
    setDefaultDocumentType() {
      // Por defecto: primer tipo de documento del país (España: TK; Colombia: FE).
      this.doctype = this.doctypes[0]?.value || "FE";
      // Al calcular los totales se ajustará automáticamente si es necesario
      this.updateTotal();
    },
    getDocumentTypeHint() {
      const code = getCurrentCountryCode();
      if (code !== "ES") {
        // En Colombia y otros países sin tramos de ticket/simplificada/completa
        // basados en monto, no aplica el aviso de umbrales legales.
        return "";
      }
      const cfg = getCurrentCountrySettings(code).country || {};
      const simplified = cfg.simplifiedInvoiceLimit ?? 0;
      const full = cfg.requiresFullInvoiceLimit ?? 0;
      const fmt = (v) => formatCurrencyAdvanced(v, null, { useNativeFormat: true });
      if (this.totals.total <= simplified) {
        return `Importe hasta ${fmt(simplified)}: Recomendado ticket básico`;
      } else if (this.totals.total <= full) {
        return `Importe entre ${fmt(simplified)} y ${fmt(full)}: Recomendada factura simplificada`;
      } else {
        return `Importe superior a ${fmt(full)}: Obligatoria factura completa`;
      }
    },
    openClientOptions() {
      this.showClientOptions = true;
    },
    handleClientTypeChange() {
      switch (this.clientType) {
        case "public":
          // Usar cliente público general
          this.client = { ...buildClientePublicoGeneral() };
          this.client.CityName = this.company.city_code;
          break;
        case "regular":
          // Abrir diálogo para seleccionar cliente existente
          this.client_dialog = true;
          this.showClientOptions = false;
          break;
        case "new":
          // Limpiar formulario para nuevo cliente
          this.clearClient();
          this.client_dialog = true;
          this.showClientOptions = false;
          break;
      }
    },

    openPaymentDialog() {
      // Inicializar el tipo de documento según el monto
      this.checkFacturaRequerida();

      // Si es la primera vez que se abre y se necesita información del cliente,
      // configurar cliente como público en general
      if (this.needsClientInfo && !this.client.PartyName) {
        this.client = { ...buildClientePublicoGeneral() };
        this.client.CityName = this.company.city_code;
      }

      // Abrir el diálogo
      this.payment_dialogo = true;
    },
    checkFacturaRequerida() {
      const code = getCurrentCountryCode();
      const cfg = getCurrentCountrySettings(code).country || {};
      const fullLimit = cfg.requiresFullInvoiceLimit ?? Infinity;

      // Si el cliente solicita factura, cambiamos al tipo de documento adecuado
      if (this.clienteSolicitaFactura) {
        this.doctype = "invoice";
        this.needsClientInfo = true;
      } else {
        // Elegir el primer doctype cuyo maxAmount cubra el total. Esto funciona
        // tanto para España (TK/FS/FC) como para Colombia (FE único).
        const target =
          this.doctypes.find((d) => this.totals.total <= d.maxAmount) ||
          this.doctypes[this.doctypes.length - 1];
        this.doctype = target.value;
        this.needsClientInfo = target.needsClient;
      }

      // El monto requiere factura si supera el límite legal del país
      this.montoRequiereFactura = this.totals.total > fullLimit;
    },
    validate_doctype() {
      // Buscar el tipo de documento seleccionado
      const selectedDocType = this.doctypes.find((doc) => doc.value === this.doctype);

      // Si el monto supera el máximo permitido para el tipo de documento seleccionado
      if (this.totals.total > selectedDocType.maxAmount) {
        // Encontrar el tipo de documento adecuado para el monto
        const properDocType = this.doctypes.find(
          (doc) => this.totals.total <= doc.maxAmount
        );

        // Actualizar el tipo de documento
        this.$set(this, "doctype", properDocType.value);

        // Mostrar mensaje informativo (con la moneda del país)
        const maxFmt = formatCurrencyAdvanced(selectedDocType.maxAmount, null, {
          useNativeFormat: true,
        });
        this.$store.commit("setSnackbar", {
          show: true,
          text: `Monto superior a ${maxFmt} - Se requiere ${properDocType.label}`,
          color: "warning",
        });

        // Actualizar si necesita información del cliente
        this.needsClientInfo = properDocType.needsClient || this.clienteSolicitaFactura;
      }
    },
    updateBags(e) {
      ////console.log(e);
      this.bags = e;
    },
    incrementQuantity() {
      this.itemEdit.cantidad = parseInt(this.itemEdit.cantidad) + 1;
      this.updateTotal();
    },
    decrementQuantity() {
      if (this.itemEdit.cantidad > 1) {
        this.itemEdit.cantidad = parseInt(this.itemEdit.cantidad) - 1;
        this.updateTotal();
      }
    },
    saveChanges() {
      // Logic to save changes to the product
      this.edit_dialog = false;
    },
    removeItem(e) {
      var index = this.cart.indexOf(e);
      if (index !== -1) {
        this.cart.splice(index, 1);
      }

      this.updateTotal();
      this.edit_dialog = false;
    },
    fastPayment() {
      this.vendor = this.vendors[0].codigo;
      const pay = {
        payment_concept: "EFECTIVO",
        payment_code: "01",
        payment_reference: "PAGO RAPIDO",
        payment_value: this.totals.unpaid,
      };
      this.payments.push({ ...pay });
      this.updateTotal();
    },
    formatCurrency(value) {
      if (!value && value !== 0) return "";
      return formatCurrencyAdvanced(value, null, { useNativeFormat: true });
    },

    handlePaymentInput(value) {
      // Remove currency symbols and separators
      const numericValue = value.replace(/[^0-9.,]/g, "");
      // Convert to a standard decimal format
      const standardizedValue = numericValue.replace(",", ".");
      // Parse as float and ensure 2 decimal places
      const floatValue = parseFloat(standardizedValue);
      // Update the value as a number with 2 decimal places
      this.payment.payment_value = isNaN(floatValue)
        ? ""
        : parseFloat(floatValue.toFixed(2));
    },
    validateID(e) {
      if (e.keyCode === 13) {
        this.get_rut();
      }
    },
    clearClient() {
      // Al "limpiar" volvemos al genérico del país, no a vacío. Así el cajero
      // puede facturar de inmediato sin tener que llenar un formulario.
      this.client = buildClientePublicoGeneral();
      this.client.CityName = this.company.city_code;
    },
    get_rut() {
      this.loading_status = true;
      var qry = {
        id_company: this.company.PartyIdentification,
        method: "POST",
        data: {
          environment: {
            type_environment_id: 1,
          },
          type_document_identification_id: this.client.typeid,
          identification_number: this.client.PartyIdentification,
        },
      };
      this.loading_status = true;
      //console.log(qry);
      fe_ws("get_acquirer", qry, (data) => {
        //console.log(data);
        this.loading_status = false;
        var rut = JSON.parse(data);
        if (rut.name) {
          this.client.PartyName = rut.name;
          this.client.client_email = rut.email;
        } else {
          this.client = createClient();
          this.client.CityName = this.company.city_code;
        }
      });
    },
    get_client(e, mail) {
      //e.preventDefault();
      var qry = {
        store: window.store.store_id,
        PartyIdentification: this.client.PartyIdentification,
      };
      webserver("get_client_info", qry, (data) => {
        // ////console.log(data);
        //this.client = data;
        //this.loading_status = false;
        if (mail && data.client_email && data.client_email !== "") {
          this.client.client_email = data.client_email;
        } else {
          if (mail) this.client.client_email = "";
        }
        if (data.AddressLine && data.AddressLine !== "") {
          this.client.AddressLine = data.AddressLine;
        } else {
          this.client.AddressLine = "";
        }
        if (data.client_phone && data.client_phone !== "") {
          this.client.client_phone = data.client_phone;
        } else {
          this.client.client_phone = "";
        }
        if (
          data.CityName &&
          data.CityName !== "" &&
          this.containsOnlyNumbers(data.CityName)
        ) {
          this.client.CityName = data.CityName;
        } else {
          this.client.CityName = this.company.city_code;
        }
      });

      ////console.log(e);
    },
    get_data_company() {
      var qry = {
        store: window.store.store_id,
        table: "f_companies",
        filters: [
          {
            field: "store_code",
            operator: "=",
            value: window.store.store_id,
          },
          {
            field: "PartyIdentification",
            operator: "=",
            value: window.store.store_business_id,
          },
        ],
      };
      this.loading_status = true;

      webserver("get_dataTable", qry, (data) => {
        this.loading_status = false;
        ////console.log("get_data_company", data);
        if (data.length > 0) {
          this.company = data[0];
          // Solo completar la ciudad del cliente genérico si todavía está vacía;
          // no pisar la de un cliente real que el cajero ya haya seleccionado.
          if (!this.client.CityName) {
            this.client.CityName = this.company.city_code;
          }
        }
      });
    },

    sumField(fld, key) {
      var dta = fld;
      return dta.reduce((a, b) => parseFloat(a) + (parseFloat(b[key]) || 0), 0);
    },
    sumFieldPrice(fld, key) {
      var dta = fld;
      return dta.reduce((a, b) => parseFloat(a) + (parseFloat(b[key]) || 0), 0);
    },
    getImageURL: function (marca, refe) {
      var account = window.store.store_id.substring(0, 6);
      var url =
        "https://moda-stc.com/photos/" + account + "/" + marca + "/" + refe + ".jpg";
      if (this.compressed_image) url = this.compressed_image;
      return url;
    },
    scroll() {
      document.getElementById("scroll-target").scrollTop = document.getElementById(
        "scroll-target"
      ).scrollHeight;
    },
    editItem(e) {
      this.itemEdit = e;
      this.edit_dialog = true;
    },
    itemUpdate(e) {
      e.preventDefault();
      this.$refs.editform.validate();
      if (this.editvalid) {
        ////console.log("Saving");
      }
    },
    get_name_typeId(e) {
      var index = this.id_lst.findIndex((itm) => itm.code === e);
      if (index >= 0) {
        return this.id_lst[index].name;
      } else {
        return "";
      }
    },
    get_name_city(e) {
      var index = this.setting["municipalities"].findIndex((itm) => itm.id === e);
      if (index >= 0) {
        return this.setting["municipalities"][index].name;
      } else {
        return "";
      }
    },
    restQty() {
      if (this.bags > 0) {
        this.bags = this.bags - 1;
      }
      // this.setSku();
    },
    addQty() {
      this.bags = this.bags + 1;
      //   this.setSku();
    },
    add2cart_st(data) {
      ////console.log("====>", data);
      var qry = {
        store: window.store.store_id,
        dbSearch: "inventory",
        filters: {
          id_pos: window.store.store_id,
          ean: data,
        },
      };
      webserver("get_catalog", qry, (data) => {
        if (data[0]) {
          this.add2cart(data[0]);
        } else {
          this.skuError = true;
        }
      });
    },
    get_product(e) {
      e.preventDefault();
      this.loading_status = true;
      var qry = {
        store: window.store.store_id,
        dbSearch: "inventory",
        filters: [
          {
            field: "id_pos",
            operator: "=",
            value: window.store.store_id,
          },
          {
            field: "ean",
            operator: "=",
            value: this.sku,
          },
        ],
      };

      this.sku = null;
      ////console.log("get_product", qry);
      webserver("get_catalog", qry, (data) => {
        this.loading_status = false;
        if (data[0]) {
          this.add2cart(data[0]);
        } else {
          this.skuError = true;
        }
      });
    },
    get_id_barcode(e) {
      //var temp = idCliente.split('\t');
      var temp = e.split(";");
      var u_id = temp[0].trim();
      var u_lastname = (temp[1].trim() + " " + temp[2].trim()).trim();
      var u_firstname = (temp[3].trim() + " " + temp[4].trim()).trim();
      var u_name = (u_firstname + " " + u_lastname).trim();
      var birthday = null;
      var sx = null;
      if (temp[5] === "0M" || temp[5] === "0F") {
        sx = temp[5].replace(/0/g, "");
        birthday =
          temp[6].substring(0, 4) +
          "-" +
          temp[6].substring(4, 6) +
          "-" +
          temp[6].substring(6, 8);
      }
      if (temp[5] === "M" || temp[5] === "F") {
        sx = temp[5];
        birthday =
          temp[6].substring(4, 8) +
          "-" +
          temp[6].substring(2, 4) +
          "-" +
          temp[6].substring(0, 2);
      }
      this.client.PartyIdentification = u_id;
      this.client.PartyName = u_name;
      this.client.client_birthday = birthday;
      this.client.sex = sx;
    },
    discountAppCart(e) {
      this.discount = parseFloat(e);
      this.discountApp();
    },
    discountApply(e) {
      if (e.keyCode === 13) {
        this.discountApp();
      }
    },
    discountApp() {
      this.cart.forEach((itm) => {
        itm.descuento = parseFloat(this.discount);
        if (itm.discount && itm.discount > 0) {
          itm.precio = itm.precio + itm.discount;
        }
        var factor = parseFloat(itm.descuento) / 100;
        itm.discount = Math.round(itm.precio * factor);
        itm.precio = parseInt(itm.precio - itm.discount);
      });
      this.discount = null;
      // this.setSku();
      this.updateTotal();
    },
    itemdiscountApply(e) {
      e.preventDefault();
      if (e.keyCode === 13) {
        if (
          this.itemEdit.tax === "" ||
          this.itemEdit.tax === null ||
          this.itemEdit.tax === undefined
        ) {
          this.itemEdit.tax = 19;
        }
        this.itemEdit.precio =
          parseFloat(this.itemEdit.precio) + parseFloat(this.itemEdit.item_discount);
        if (this.itemEdit.descuento === "") {
          this.itemEdit.descuento = 0;
        } else {
          this.itemEdit.descuento = parseFloat(this.itemEdit.descuento);
        }
        var tax_value = parseFloat(this.itemEdit.tax) / 100 + 1;
        if (
          parseInt(this.itemEdit.descuento) > 0 &&
          parseInt(this.itemEdit.descuento) <= 100
        ) {
          var factor = parseFloat(this.itemEdit.descuento) / 100;
          this.itemEdit.discount = parseFloat((this.itemEdit.precio * factor).toFixed(2));
          this.itemEdit.item_discount = this.itemEdit.discount.toFixed(2);
        } else {
          this.itemEdit.discount = parseFloat(this.itemEdit.descuento);
          this.itemEdit.item_discount = this.itemEdit.discount.toFixed(2);
        }
        this.itemEdit.precio = parseFloat(
          (this.itemEdit.precio - this.itemEdit.discount).toFixed(2)
        );
        this.itemEdit.price_amount = parseFloat(
          (this.itemEdit.precio / tax_value).toFixed(2)
        );
        this.itemEdit.item_tax = parseFloat(
          (this.itemEdit.precio - this.itemEdit.price_amount).toFixed(2)
        );
        this.updateTotal();
      }
    },

    itemDetail(item) {
      if (!item) return "";
      // Mismo formato que el slot del diálogo de búsqueda (marca-refe-color-talla),
      // saltando campos vacíos para que la línea quede legible.
      return [item.marca, item.refe, item.color, item.talla]
        .filter((v) => v !== null && v !== undefined && String(v).trim() !== "")
        .join(" - ");
    },

    add2cart(e) {
      // Asegúrate de que esta implementación esté en Registradora.vue
      console.log("Producto recibido en add2cart:", e);
      const nItm = { ...e };
      var STC = 1;

      // Mantener la cantidad como número
      nItm.qty = parseFloat(nItm.cantidad);

      // Asegurar que el precio mantiene sus decimales exactos
      // NO realizamos operaciones aritméticas que puedan provocar redondeo
      nItm.precio = parseFloat(nItm.precio) * STC;

      if (nItm.tax === "" || nItm.tax === null || nItm.tax === undefined) {
        nItm.tax = 19;
      }

      if (nItm.cantidad === null) {
        nItm.cantidad = 1;
      } else {
        nItm.cantidad = parseFloat(nItm.cantidad);
      }

      var tax_value = parseFloat(nItm.tax) / 100 + 1;

      if (parseInt(nItm.descuento) > 0 && parseInt(nItm.descuento) <= 100) {
        var factor = parseInt(nItm.descuento) / 100;
        // Usar parseFloat + toFixed para preservar exactamente 2 decimales sin redondear incorrectamente
        nItm.discount = parseFloat((nItm.precio * factor).toFixed(2));
        nItm.item_discount = nItm.discount.toFixed(2);
      } else {
        nItm.discount = parseFloat(nItm.descuento);
        nItm.item_discount = nItm.discount.toFixed(2);
      }

      // Preservar decimales en el precio después del descuento
      nItm.precio = parseFloat((nItm.precio - nItm.discount).toFixed(2));

      // Calcular price_amount y item_tax preservando decimales
      nItm.price_amount = parseFloat((nItm.precio / tax_value).toFixed(2));
      nItm.item_tax = parseFloat((nItm.precio - nItm.price_amount).toFixed(2));

      // El resto de la función sigue igual...
      var index = this.cart.findIndex((itm) => itm.ean === nItm.ean);
      if (index === -1) {
        this.cart.push(nItm);
      } else {
        this.cart[index].cantidad += nItm.cantidad;
      }
      this.productAdded = true;
      this.updateTotal();
    },

    filter: function (evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    addPayment(e) {
      e.preventDefault();
      if (this.pay_mode) {
        if (this.pay_mode.codigo === "01") {
          if (this.payment.payment_value > this.totals.unpaid) {
            var cmb =
              parseFloat(this.payment.payment_value) - parseFloat(this.totals.unpaid);
            this.payment.payment_concept = this.pay_mode.valor;
            this.payment.payment_code = this.pay_mode.codigo;
            this.payment.payment_value = this.totals.unpaid;
            this.payments.push({ ...this.payment });

            var cambio = {
              payment_concept: "EFECTIVO",
              payment_code: "01",
              payment_reference: " Cambio $ " + cmb,
              payment_value: 0,
            };
            this.payments.push({ ...cambio });
            this.updateTotal();
          } else {
            this.payment.payment_concept = this.pay_mode.valor;
            this.payment.payment_code = this.pay_mode.codigo;
            this.payments.push({ ...this.payment });
            this.updateTotal();
          }
          this.pay_mode = {
            codigo: "01",
            valor: "EFECTIVO",
          };
        } else {
          if (this.payment.payment_value <= this.totals.unpaid) {
            this.payment.payment_concept = this.pay_mode.valor;
            this.payment.payment_code = this.pay_mode.codigo;
            this.payments.push({ ...this.payment });
            this.updateTotal();
            this.pay_mode = {
              codigo: "01",
              valor: "EFECTIVO",
            };
          } else {
            this.payValue = true;
            this.payment.payment_value = 0;
          }
        }
      }
    },
    delete_payment(e) {
      var index = this.payments.indexOf(e);
      if (index !== -1) {
        this.payments.splice(index, 1);
      }
      this.updateTotal();
      //this.setSku();
    },
    delete_item(e) {
      var index = this.cart.indexOf(e);
      if (index !== -1) {
        this.cart.splice(index, 1);
      }
      // this.setSku();
      this.updateTotal();
    },
    updateRefe() {
      if (this.payment.payment_reference.length > 0) {
        this.payRefe = false;
      }
    },
    containsOnlyNumbers(str) {
      return /^\d+$/.test(str);
    },
    validate_invoice() {
      var rspns = false;

      if (this.client.CityName) {
        if (this.containsOnlyNumbers(this.client.CityName)) {
          this.validations[7].status = true;
        } else {
          this.validations[7].status = false;
        }

        // rspns = true;
      } else {
        this.validations[7].status = false;
        // rspns = false;
      }

      if (this.totals.total > 0) {
        this.validations[6].status = true;
        //rspns = true;
      } else {
        this.validations[6].status = false;
        //rspns = false;
      }

      if (this.totals.total > 280037 && this.doctype === "pos") {
        this.validations[5].status = false;
        //rspns = true;
      } else {
        this.validations[5].status = true;
        //rspns = false;
      }

      if (this.vendor) {
        this.validations[4].status = true;
        this.validations[4].label = "";
      } else {
        this.validations[4].status = false;
        this.validations[4].label = "Vendedor es Requerido";
        // rspns = true;
      }

      if (this.client.typeid) {
        this.validations[3].status = true;
        // rspns = true;
      } else {
        this.validations[3].status = false;
        // rspns = false;
      }

      if (this.client.PartyIdentification) {
        this.validations[2].status = true;
        // rspns = true;
      } else {
        this.validations[2].status = false;
        //rspns = false;
      }
      if (this.client.client_email) {
        var emailTest = String(this.client.client_email)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
        //////console.log(emailTest);
        if (emailTest) {
          this.validations[1].status = true;
        } else {
          this.validations[1].status = false;
        }

        // rspns = true;
      } else {
        if (this.client.PartyName === "CONSUMIDOR FINAL") {
          this.validations[1].status = true;
        } else {
          this.validations[1].status = false;
        }
        // rspns = false;
      }

      if (this.client.PartyName !== "") {
        this.validations[0].status = true;
        //rspns = true;
      } else {
        this.validations[0].status = false;
        // rspns = false;
      }

      // var rspns=true;

      // if (this.totals.total>0 ) {

      //   rspns = false;
      //  } else {

      //   rspns = true;
      //  }
      // var newArray = this.validations.filter(function (el) {
      //   return el.status = true;
      // });

      this.validations.forEach((itm) => {
        //////console.log(itm);

        if (!itm.status) {
          rspns = true;
        }
      });
      return rspns;
    },
    updateTotal() {
      this.totals.qty = 0;
      this.totals.total = 0;
      this.totals.tax = 0;

      this.totals.paid = 0;
      this.totals.unpaid = 0;
      this.cart.forEach((itm) => {
        this.totals.qty += parseFloat(itm.cantidad);
        this.totals.total += parseFloat(
          (parseFloat(itm.cantidad) * parseFloat(itm.precio)).toFixed(2)
        );
        this.totals.tax += parseFloat(
          (
            (parseFloat(itm.cantidad) * parseFloat(itm.precio) * parseFloat(itm.tax)) /
            100
          ).toFixed(2)
        );
      });

      if (this.bags > 0) {
        // Assuming 70 cents per bag for Euro instead of 70 pesos
        this.totals.total += parseFloat((this.bags * 0.7).toFixed(2));
      }

      this.payments.forEach((itm) => {
        if (itm.payment_code !== "00") {
          this.totals.paid += parseFloat(parseFloat(itm.payment_value).toFixed(2));
        }
      });

      this.totals.unpaid = parseFloat((this.totals.total - this.totals.paid).toFixed(2));
      this.payment.payment_value = this.totals.unpaid;
      if (this.totals.unpaid === 0 && this.totals.total > 0) {
        this.payment_dialogo = false;
        this.topay = true;
        this.save_invoice();
      } else {
        this.topay = false;
      }
      this.checkFacturaRequerida();
    },
    get_vendors() {
      var qry = {
        store: window.store.store_id,
      };
      this.loading_vendors = true;
      webserver("vendors", qry, (data) => {
        this.loading_vendors = false;
        ////console.log(data);
        data.forEach((itm) => {
          itm.nombre = itm.nombre.toUpperCase();
        });
        window.vendors = data;
        this.vendors = data;
      });
    },
    setSku() {
      setTimeout(() => {
        // document.getElementById("sku").focus();
      }, 50);
    },

    resetInvoice() {
      this.filters = { categoria: "", marca: "", refe: "", id_pos: "" };
      this.bags = 0;

      // Tras cobrar una venta, la siguiente arranca con el cliente genérico
      // del país (CONSUMIDOR FINAL en CO), no con un formulario vacío.
      this.client = buildClientePublicoGeneral();
      this.payment = createPayment();
      this.cart = [];
      this.payments = [];
      this.client.CityName = this.company.city_code;
      this.updateTotal();
    },

    print_doc() {
      var a = window.open("", "", "height=600, width=400");
      a.document.write('<img src="' + this.dataURL + '"  width="100%">');
      a.print();
      a.document.close();
      setTimeout(() => {
        a.close();
      }, 500);
    },
    search_inventory(e) {
      e.preventDefault();
      var qry = {
        store: window.store.store_id,
        dbSearch: "inventory",
      };
      qry.filters = [
        {
          field: "id_pos",
          operator: "=",
          value: window.store.store_id.slice(0, 6),
        },
        {
          field: this.filters.field,
          operator: " LIKE ",
          value: this.filters.value,
        },
      ];

      webserver("get_catalog", qry, (data) => {
        this.loading_status = false;
        ////console.log(data);
        this.inventory_lst = data;
      });
    },
    get_store_ls() {
      var qry = {
        store: window.store.store_id,
      };
      this.loading_status = true;
      webserver("get_inventory_st", qry, (data) => {
        this.loading_status = false;
        this.st_items = data;
      });
    },
    changeMenu(e) {
      this.menu_selected = this.itemsby[e];
      ////console.log(this.menu_selected);
      this.menuName = e;
    },
    get_options(e) {
      return this.groupBy(e.split(","));
    },
    groupBy(arr) {
      var group = [];
      var option = { ean: null, description: null };
      for (let i = 0; i < arr.length - 1; i += 3) {
        ////console.log(arr[i]);
        var color = "";
        if (this.colors[arr[i + 1]]) {
          color = this.colors[arr[i + 1]].valor;
        } else {
          color = arr[i + 1];
        }
        option = { ean: arr[i], description: color + " - " + arr[i + 2] };
        group.push(option);
        //////console.log(option);
      }
      return group;
    },
    save_client() {
      var qry = {
        store: window.store.store_id,
        party: this.client,
      };
      webserver("put_client_info", qry, () => {
        //this.resetDoc();
        //this.loading_vendors = false;
        this.client_dialog = false;
        ////console.log(data);
        //this.print_doc(data);
      });
    },
    save_invoice() {
      // Cliente: si no hay PartyName/PartyIdentification, caer al genérico.
      // Si el cajero seleccionó uno real, se respeta tal cual.
      let buyer = this.client;
      if (!buyer || !buyer.PartyName || !buyer.PartyIdentification) {
        buyer = { ...buildClientePublicoGeneral() };
        buyer.CityName = this.company.city_code;
      }

      // Asegurar typeid presente (el backend FE lo requiere). Si por alguna
      // razón quedó vacío, usar el del genérico del país.
      if (!buyer.typeid) {
        buyer.typeid = buildClientePublicoGeneral().typeid;
      }

      // Procesar items con la misma forma que InvoicePOS: qty + discount + los
      // price_amount/item_tax que ya se calcularon al hacer add2cart.
      const processedItems = this.cart.map((item) => ({
        ...item,
        qty: item.cantidad,
        discount: item.discount || 0,
      }));

      var invoice = {
        buyer: buyer,
        doc: {
          doc_type: this.doctype,
          doc_value: this.totals.total,
          store: window.store.store_id,
          userId: window.profile.user_email,
          vendor: this.vendor,
        },
        items: processedItems,
        payments: this.payments,
        seller: window.seller,
        store: window.store.store_id,
      };

      console.log("[Registradora] Enviando factura al servidor:", invoice);
      this.loading_status = true;
      webserver("post_invoice", invoice, (data) => {
        console.log("[Registradora] Respuesta post_invoice:", data);
        this.loading_status = false;
        if (!data || data.error) {
          this.$store.commit("setSnackbar", {
            show: true,
            text: (data && data.error) || "Error generando el documento",
            color: "error",
          });
          this.loading_vendors = false;
          return;
        }
        this.item = { ...data };
        this.docViewdialog = true;
        this.nInvoice = true;
        this.resetInvoice();
        this.loading_vendors = false;
      });
    },
    refresh_view() {
      var e = this.item;
      var issudate = e.issuedate.split(" ");
      var doc = {
        store: e.store,
        issueDate: issudate[0],
        did: e.doc_number,
      };
      this.loading_status = true;
      webserver("get_invoice_fe", doc, (data) => {
        this.loading_status = false;
        this.item = data;
        this.docViewdialog = true;
        this.loading_vendors = false;
      });
    },
  },

  watch: {
    bags: function () {
      var idx = this.payments.findIndex((itm) => itm.payment_code === "00");
      if (idx === -1) {
        this.payments.push({
          payment_code: "00",
          payment_concept: "Bolsas",
          payment_reference: "",
          payment_value: parseFloat((0.7 * this.bags).toFixed(2)),
        });
      } else {
        this.payments[idx].payment_value = parseFloat((0.7 * this.bags).toFixed(2));
        if (this.bags <= 0) {
          this.payments.splice(idx, 1);
        }
      }

      this.updateTotal();
    },
  },
  updated() {
    //this.scroll();
  },
  totalAmount() {
    return this.total || this.updateTotal();
  },
  formattedPaymentValue() {
    return this.formatCurrency(this.payment.payment_value || 0);
  },
};
</script>

<style lang="scss">
.reg-wrapper {
  height: calc(100vh - 128px) !important;
}
.bg-pos {
  //  background: url("../assets/login.jpg") no-repeat center center fixed;
  background: #cfd8dc;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 100%;
}

.fixed-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}

.center-input input {
  text-align: center;
  width: 10px;
}

.right-input input {
  text-align: right;
  width: 10px;
}

.scroll {
  overflow-y: scroll;
  max-height: 90vh;
}

.cart-list {
  flex-grow: 1;
  overflow: auto;
  height: 60vh;
}
.price {
  font-size: 1.5em !important;
  font-weight: bold !important;
}
</style>

<style scoped>
.checkout-dialog {
  border-radius: 8px;
}
.checkout-header {
  height: 64px;
}
.checkout-title {
  font-size: 24px;
  font-weight: 600;
}
.gradient-text {
  background: linear-gradient(45deg, #6772e5, #3ecf8e);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
}
.gradient-button {
  background: linear-gradient(45deg, #6772e5, #828bec) !important;
  transition: opacity 0.3s ease;
  color: white !important;
}
.gradient-button:hover {
  opacity: 0.9;
}
.customer-info {
  background-color: #f9fafc;
  border-radius: 8px;
  border-color: #e0e0e0;
}
.v-text-field ::v-deep input,
.v-select ::v-deep .v-select__selection {
  font-size: 16px;
}
.v-btn {
  text-transform: none;
  letter-spacing: 0.5px;
}
</style>

<style scoped>
.client-dialog {
  border-radius: 8px;
}
.client-header {
  height: 64px;
}
.client-title {
  font-size: 24px;
  font-weight: 600;
}
.gradient-text {
  background: linear-gradient(45deg, #6772e5, #3ecf8e);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
}
.gradient-button {
  background: linear-gradient(45deg, #6772e5, #3ecf8e) !important;
  transition: opacity 0.3s ease;
}
.gradient-button:hover {
  opacity: 0.9;
}
.v-text-field ::v-deep input,
.v-select ::v-deep .v-select__selection {
  font-size: 16px;
}
.v-btn {
  text-transform: none;
  letter-spacing: 0.5px;
}
</style>
